import { QueryKey as OriginQueryKey, useQuery, UseQueryOptions } from '@tanstack/react-query';

import { QUERY_KEY } from '@query/keys';
import { ApiRepository } from '@repositories/api';

import type {
  GetMonthlyActiveUsersListRequestPayload,
  MonthlyActiveUsersListResponseOK,
  MonthlyActiveUsersListResponseError
} from '@repositories/api/statistics.types';
import type { AxiosResponse } from 'axios';

type Props<Data extends AxiosResponse, ErrorResponse, QueryKey extends OriginQueryKey> = {
  queryParams: GetMonthlyActiveUsersListRequestPayload['queryParams'];
  options?: Omit<
    UseQueryOptions<Data, ErrorResponse, Data['data']['data'], QueryKey>,
    'queryKey' | 'queryFn' | 'initialData'
  >;
};

function useGetMonthlyActiveUsersListQuery<
  Data extends MonthlyActiveUsersListResponseOK,
  ErrorResponse extends MonthlyActiveUsersListResponseError
>({
  queryParams,
  options
}: Props<
  Data,
  ErrorResponse,
  ReturnType<typeof QUERY_KEY.STATISTICS.GET_MONTHLY_ACTIVE_USERS_LIST>
>) {
  return useQuery({
    queryKey: QUERY_KEY.STATISTICS.GET_MONTHLY_ACTIVE_USERS_LIST({ queryParams }),
    queryFn: () => {
      return ApiRepository.statistics.getMonthlyActiveUsersList({ queryParams });
    },
    select: (data) => data.data.data,
    ...options
  });
}

export { useGetMonthlyActiveUsersListQuery };
